import { KnowledgeBaseLink } from '@ardoq/knowledge-base';
import { type I18nLocale, t } from '@ardoq/i18n';
import type { TrackedHelpItem } from '../trackedHelpItems';
import { toHelpItems } from './pageHelp';

export const getDataAnalysisHelpItems = (
  i18nLocale: I18nLocale
): TrackedHelpItem[] =>
  toHelpItems(i18nLocale, {
    panelHeader: {
      label: t(
        i18nLocale,
        'views:navbar.helpItem.dataAnalysis.label',
        'Data Analysis'
      ),
      description: t(
        i18nLocale,
        'views:navbar.helpItem.dataAnalysis.description',
        'Discover insights that inform decisions across your organization.'
      ),
    },
    articles: [
      {
        label: t(
          i18nLocale,
          'views:navbar.helpItem.dataAnalysisKnowledgeBase.label',
          'Data Analysis'
        ),
        description: t(
          i18nLocale,
          'views:navbar.helpItem.dataAnalysisKnowledgeBase.description',
          'Learn how to find useful information, draw conclusions, and support decision-making in your organization.'
        ),
        href: KnowledgeBaseLink.DATA_ANALYSIS_COLLECTION,
      },
    ],
    whatsNew: [],
    tours: [],
    videos: [],
  });
